import { render } from "./SchoolDifferentiationBlog.vue?vue&type=template&id=7651d667&scoped=true"
import script from "./SchoolDifferentiationBlog.vue?vue&type=script&lang=js"
export * from "./SchoolDifferentiationBlog.vue?vue&type=script&lang=js"

import "./SchoolDifferentiationBlog.vue?vue&type=style&index=0&id=7651d667&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7651d667"]])

export default __exports__